@if (user) {
  <section class="no-auth-page">
    <header>
      <h3>
        {{
          (isAnInvite
            ? 'shared.setNewPassword.createPassword'
            : 'shared.setNewPassword.resetYourPassword'
          ) | translate
        }}
      </h3>
    </header>
    <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
      <ht-input
        type="hidden"
        formControlName="email"
        style="display: none"
      ></ht-input>
      <div class="ht-form-item">
        <div class="ht-form-item-title">
          {{ 'shared.setNewPassword.newPassword' | translate }}
        </div>
        <div class="ht-form-item-control">
          <ht-input
            [label]="'shared.setNewPassword.passwordLabel' | translate"
            type="password"
            formControlName="password"
            [fullWidth]="true"
            [helpText]="'shared.setNewPassword.minCharactersHelp' | translate"
          ></ht-input>
        </div>
      </div>
      <div class="ht-form-item">
        <div class="ht-form-item-title">
          {{ 'shared.setNewPassword.repeatPassword' | translate }}
        </div>
        <div class="ht-form-item-control">
          <ht-input
            [label]="'shared.setNewPassword.repeatPassword' | translate"
            type="password"
            formControlName="checkPassword"
            [fullWidth]="true"
          ></ht-input>
        </div>
      </div>
      @if (form.errors?.serverError) {
        <div class="ht-form-row">
          <div class="error-alert">
            <i class="fa-solid fa-circle-xmark"></i>
            <span>{{ form.errors?.serverError }}</span>
          </div>
        </div>
      }
      <div class="ht-form-actions">
        <button
          ht-button-primary
          [fullWidth]="true"
          type="submit"
          size="large"
          [isLoading]="isLoading"
        >
          {{ 'shared.setNewPassword.savePassword' | translate }}
        </button>
      </div>
    </form>
  </section>
}
